import { JobDetails } from "../types";

export abstract class BaseQueue {
  protected static queue = new Map<string, JobDetails>();

  // tracks number of idle jobs to avoid iterating over the queue
  protected static idleJobs = 0;

  get hasNext() {
    return BaseQueue.idleJobs > 0;
  }

  public static enqueue(key: string, fn: () => Promise<void>) {
    BaseQueue.queue.set(key, { queuedAt: new Date(), job: fn });
    this.idleJobs++;
  }

  public static remove(key: string) {
    BaseQueue.queue.delete(key);

    if (this.idleJobs > 0) {
      this.idleJobs--;
    }
  }

  public static async processJob(key: string) {
    const job = BaseQueue.queue.get(key);
    if (!job) return;

    if (this.idleJobs > 0) {
      this.idleJobs--;
    }

    job.startedAt = new Date();
    await job.job();

    job.completedAt = new Date();
    BaseQueue.queue.delete(key);
  }
}
